const FORM_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[formManagementExperience] createForm',
  SET_CREATED: '[formManagementExperience] setCreated',
  EDIT: '[formManagementExperience] editForm',
  UPDATE_ENABLED_ATTRIBUTE: '[formManagementExperience] updateEnabledAttribute',
  DELETE: '[formManagementExperience] deleteForm'
}

export default FORM_MANAGEMENT_EXPERIENCE_TYPES
